import React from 'react';
import yellowAttention from '../../images/AttentionYellow.svg';

const AttentionIcon = (props: { id?: string; onClick: (event: any) => void; title: string }) => {
  return (
    <img
      className={'ml-3 position-relative'}
      height="18px"
      width="18px"
      id={props.id}
      src={yellowAttention}
      alt="Attention icon"
      style={{ cursor: 'pointer', bottom: '2px' }}
      onClick={props.onClick}
    />
  );
};

export default AttentionIcon;
